import { useEffect, useState } from 'react';
import { fetchPublicAchievements, type PublicAchievementsResponse } from './achievementsApi';
import { HopperIcon } from '../ui/icons/HopperIcon';

export function PublicAchievementsCard({ userId }: { userId: string }) {
  const [data, setData] = useState<PublicAchievementsResponse | null>(null);

  useEffect(() => {
    let cancelled = false;
    void fetchPublicAchievements(userId).then((response) => { if (!cancelled) setData(response); }).catch(() => { if (!cancelled) setData(null); });
    return () => { cancelled = true; };
  }, [userId]);

  if (!data || data.profile_hidden || data.achievements.length === 0) return null;

  return (
    <section className="profile-reference-card public-achievements-card">
      <div className="profile-reference-card__heading">
        <h2>Достижения</h2>
        <span>{data.achievements.length} открыто</span>
      </div>
      <div className="public-achievements-list">
        {data.achievements.map((achievement) => (
          <div className="public-achievement-chip" key={achievement.id}>
            {achievement.icon_url ? <img src={achievement.icon_url} alt="" /> : <HopperIcon name="trophy" size={20} />}
            <span><strong>{achievement.family_name}</strong><small>{achievement.name}</small></span>
          </div>
        ))}
      </div>
    </section>
  );
}
